import { documentsActions } from './documents.actions';
import { actions } from './new-document.actions';
import { filterNewConst } from '../../constants/documentFilterNew.constantas';
import moment from 'moment';
import store from '../../../../store';
import { dateRangeOrgs } from '../reducers/documentFilterNewReducer';

const {
  RESET_FILTER_DOCUMENT,
  APPLY_TYPE_ID,
  APPLY_COMPANY_ID,
  APPLY_TOPIC,
  APPLY_DATE_RANGE,
  APPLY_DATE_RANGE_FIELD,
  APPLY_STATUSES,
  APPLY_SUBTYPES,
  APPLY_SOURCE_DATE_DOCUMENT,
  APPLY_SOURCE_DATE_NUMBER,
  APPLY_EXECUTOR,
  APPLY_RESPONSIBLE_WORKER,
  APPLY_ORGS,
  APPLY_CREATOR,
  APPLY_STREET,
  APPLY_HOUSE,
  APPLY_FLATS,
  SET_FILTER_CHANGE,
  SET_DOCUMENT_FILTER_VALUES,
  APPLY_VIEW_OTHERO_DOCS_SELECTED,
  APPLY_DEADLINE_DATE,
  APPLY_TOPIC_IDS,
  APPLY_ORGS_FILTER,
  APPLY_SOURCE,
} = filterNewConst;

export const resetFilter = () => {
  return (dispatch) => {
    dispatch({ type: RESET_FILTER_DOCUMENT });
    dispatch(documentsActions.setExpiredModeValue(false));

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
    dispatch(documentsActions.fetchDocuments());
  };
};

export const applyDateRange = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_DATE_RANGE,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyDateRangeField = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_DATE_RANGE_FIELD,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyType = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_TYPE_ID,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyTopic = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_TOPIC,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyStatuses = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_STATUSES,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyTopicIds = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_TOPIC_IDS,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applySubtypes = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_SUBTYPES,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applySourceDateDocument = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_SOURCE_DATE_DOCUMENT,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applySourceDocumentNumber = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_SOURCE_DATE_NUMBER,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyDeadlineDate = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_DEADLINE_DATE,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyExecuter = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_EXECUTOR,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};
export const applyResponsibleWorker = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_RESPONSIBLE_WORKER,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyOrgs = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_ORGS,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyCreator = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_CREATOR,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyOrgsFilter = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_ORGS_FILTER,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));

    dispatch(documentsActions.fetchDocuments());
  };
};

export const applyStreet = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_STREET,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};
export const applyHouse = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_HOUSE,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyFlats = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_FLATS,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applyViewOtherDocsSelected = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_VIEW_OTHERO_DOCS_SELECTED,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const setFilterChanged = (payload) => ({
  type: SET_FILTER_CHANGE,
  payload,
});

export const setDocumentFilterValues = (filterValues) => {
  return (dispatch) => {
    const { dateRange, bindDocument } = filterValues;
    const filter = {
      ...filterValues,
      dateRange: [moment(dateRange[0]), moment(dateRange[1])],
      ...(bindDocument && [moment(bindDocument[0]), moment(bindDocument[1])]),
    };

    dispatch({
      type: SET_DOCUMENT_FILTER_VALUES,
      payload: filter,
    });

    documentsActions.fetchRequestsTimer(dispatch);
  };
};

export const chooseDocumentFilterNew = (id) => {
  return (dispatch) => {
    const existingFilters = store.getState().documentFilterStore.filters.data;

    const chosenFilter = existingFilters.find((existingFilter) => {
      return existingFilter.id === id;
    });

    if (!!chosenFilter) {
      dispatch(
        actions.setChosenDocumentsFilter({
          id: chosenFilter?.id,
          name: chosenFilter?.name.trim(),
        })
      );
      dispatch(setDocumentFilterValues(JSON.parse(chosenFilter.filter)));
    }
  };
};

export const applyCompany = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: APPLY_COMPANY_ID,
      payload: value,
    });

    const stateFilter = getState().documentFilterNewStore;

    const period1 = stateFilter.dateRange;
    const period2 = dateRangeOrgs;

    dispatch(applyExecuter(null));
    dispatch(applyResponsibleWorker(null));

    if (!(period1[0].isSame(period2[0]) && period1[1].isSame(period2[1]))) {
      dispatch(applyOrgs([]));
    }

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};

export const applySource = (value) => {
  return (dispatch) => {
    dispatch({
      type: APPLY_SOURCE,
      payload: value,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  };
};
